import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Button, Checkbox, Icon, Alert, List } from 'antd'
import { policyType } from '@texts/policy'
import { users } from '@services/api'
@inject((store: any) => {
    const { popupStore, clientsStore } = store
    return { popupStore, clientsStore }
})
@observer
export default class ClientsPopup extends Component<any, any> {
    state: any = {
        errors: {}
    }

    toggleAttachedPolicy = () => {
        const { searchParams, clientsByInsuranceCase } = this.props.clientsStore
        if ('policy_id' in searchParams && +searchParams.policy_id) {
            clientsByInsuranceCase({ policy_id: 0 })
        } else {
            clientsByInsuranceCase({ policy_id: 1 })
        }
    }

    handlePageChange = async page => {
        const { changePage, clientsByInsuranceCase } = this.props.clientsStore
        await changePage(page)
        clientsByInsuranceCase({})
    }

    handleUpdateInsuranceCases = async user_id => {
        const { updateInsuranceCase } = this.props.clientsStore
        await updateInsuranceCase(user_id)
    }

    closePopup = () => {
        this.props.popupClosed()
        this.props.popupStore.togglePopup(false)
    }

    render() {
        const {
            popupType,
            info: { company_id, mainCat, subCat, company, policy_type }
        } = this.props.popupStore
        const {
            list,
            loading,
            errors,
            searchParams,
            paging: { page, perPage: pageSize, total }
        } = this.props.clientsStore
        const footerButtons = <Button onClick={this.closePopup}>סגור</Button>
        return (
            <Modal
                title={'רשימת משתמשים לפי תיק ביטוחי'}
                visible={popupType === 'clientsPopup'}
                cancelText="ביטול"
                footer={footerButtons}
                onCancel={this.closePopup}
                width={700}
            >
                <div style={{ marginBottom: '1rem' }}>
                    <strong>תיק ביטוחי -</strong> קטגוריה ראשית: <u>{mainCat}</u> | קטגוריה משנית: <u>{subCat}</u> |
                    חברה: <u>{company}</u> | סוג פוליסה: <u>{policyType[policy_type]}</u>
                </div>
                {errors ? <Alert style={{ margin: '1rem 0' }} message={errors} type="error" /> : ''}
                <div style={{ marginBottom: '1rem' }}>
                    <Checkbox disabled={loading} checked={searchParams.policy_id} onChange={this.toggleAttachedPolicy}>
                        <strong>הצג רק לקוחות ללא זיהוי הפוליסה</strong>
                    </Checkbox>
                </div>
                <List
                    style={{ padding: '0 0 2rem 0' }}
                    dataSource={list}
                    loading={loading}
                    renderItem={item => {
                        const failStyles = !item['policy_id']
                            ? {
                                  backgroundColor: '#ffcaca',
                                  padding: '0.5rem',
                                  color: 'red'
                              }
                            : {}
                        return (
                            <List.Item
                                key={item['user_id']}
                                style={{
                                    width: '100%',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    padding: '0.5rem 0',
                                    ...failStyles
                                }}
                            >
                                <div>
                                    <a
                                        target="_blank"
                                        style={{ color: 'black', textDecoration: 'underline' }}
                                        href={`/clients/${item['user_id']}`}
                                    >
                                        {item['user_id']} - {item['first_name']} {item['last_name']}
                                    </a>
                                </div>
                                <div>
                                    {item['policy_id'] ? (
                                        <a
                                            target="_blank"
                                            style={{ color: 'black', textDecoration: 'underline' }}
                                            href={`/insurance/${company_id}/${item['policy_id']}`}
                                        >
                                            פוליסה מקושרת - {item['policy_id']}
                                        </a>
                                    ) : (
                                        <>
                                            <strong>אין קישור לפוליסה - </strong>
                                            <Button
                                                disabled={loading}
                                                onClick={() => this.handleUpdateInsuranceCases(item['user_id'])}
                                                style={{ padding: '0 1rem', marginLeft: '0' }}
                                                size="small"
                                            >
                                                {loading ? <Icon type="loading" /> : <Icon type="reload" />} עדכן תיק
                                                ביטוחי
                                            </Button>
                                        </>
                                    )}
                                </div>
                            </List.Item>
                        )
                    }}
                    pagination={{
                        current: +page,
                        total,
                        pageSize,
                        onChange: e => this.handlePageChange(e)
                    }}
                />
            </Modal>
        )
    }
}
